import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FileText, Plus, Trash2, Edit } from "lucide-react";
import BoardTable from "../../components/common/board/BoardTable";
import BoardToolbar from "../../components/common/board/BoardToolbar";
import PageHeader from "../../components/common/ui/PageHeader";
import BoardPagination from "../../components/common/board/BoardPagination";
import * as approvalTypeApi from "../../api/approval/type";

export default function ApprovalTypeList() {
  const { id: projectId } = useParams();
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const loadList = async () => {
    if (!projectId) return;
    setLoading(true);
    try {
      const res = await approvalTypeApi.getTypeList(projectId);
      setRows(res || []);
    } catch (err) {
      console.error("결재 문서 유형 목록 불러오기 실패:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadList();
  }, [projectId]);

  const handleDelete = async (id) => {
    if (!window.confirm("삭제하시겠습니까?")) return;
    try {
      await approvalTypeApi.deleteType(projectId, id);
      await loadList();
    } catch (err) {
      alert("삭제 실패");
    }
  };

  // 검색 + 페이지네이션
  const filtered = rows.filter(
    (r) =>
      r.name?.toLowerCase().includes(search.toLowerCase()) ||
      r.title?.toLowerCase().includes(search.toLowerCase())
  );
  const startIndex = (page - 1) * pageSize;
  const paged = filtered.slice(startIndex, startIndex + pageSize);

  const columns = [
    {
      key: "name",
      header: "양식명",
      render: (row) => row.name,
    },
    {
      key: "code",
      header: "코드",
      //   width: "80px",
    },
    {
      key: "title",
      header: "제목 예시",
      render: (row) => row.title || "-",
    },
    {
      key: "actions",
      header: "관리",
      //   width: "120px",
      render: (row) => (
        <div className="flex gap-2 justify-center">
          <button
            onClick={(e) => {
              e.stopPropagation(); // ✅ 클릭 전파 막기
              navigate(`/project/${projectId}/approval/type/${row.id}`);
            }}
            className="p-1.5 rounded hover:bg-blue-50 text-blue-600"
            title="편집"
          >
            <Edit className="w-4 h-4" />
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation(); // ✅ 클릭 전파 막기
              handleDelete(row.id);
            }}
            className="p-1.5 rounded hover:bg-red-50 text-red-500"
            title="삭제"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="p-6 space-y-4">

      <PageHeader>결재 문서양식 리스트</PageHeader>
      <BoardToolbar
        right={
          <>
            <div>
              <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="양식명 또는 제목 검색"
                className="border rounded px-2 py-1 text-sm w-64"
              />
            </div>
            <button
              onClick={() =>
                navigate(`/project/${projectId}/approval/type/new`, {
                  state: { mode: "add" },
                })
              }
              className="btn-save"
            >
              새 양식 등록
            </button>
          </>
        }
      />

      <BoardTable
        columns={columns}
        rows={paged}
        loading={loading}
        keyField="id"
        onRowClick={(row) =>
          navigate(`/project/${projectId}/approval/request/new`, {
            state: { selectedType: row },
          })
        }
      />
      <BoardPagination
        page={page}
        pageSize={pageSize}
        total={filtered.length}
        onPageChange={setPage}
      />
    </div>
  );
}
